import type { CommunityThreadContextType } from './communityThreadNotificationsService'

const COMMUNITY_THREAD_NOTIFICATIONS_AUTO_ENABLED =
  'community-thread-notifications:auto-enabled'

export type CommunityThreadNotificationsAutoEnabledDetail = {
  contextType: CommunityThreadContextType
  contextId: number
}

function normalizeContextId(raw: unknown): number | null {
  const id = Number(raw)
  if (!Number.isFinite(id) || id <= 0) return null
  return Math.floor(id)
}

export function emitCommunityThreadNotificationsAutoEnabled(
  detail: CommunityThreadNotificationsAutoEnabledDetail,
): void {
  const id = normalizeContextId(detail.contextId)
  if (!id) return
  try {
    window.dispatchEvent(
      new CustomEvent(COMMUNITY_THREAD_NOTIFICATIONS_AUTO_ENABLED, {
        detail: { contextType: detail.contextType, contextId: id },
      }),
    )
  } catch {
    // ignore
  }
}

export function subscribeCommunityThreadNotificationsAutoEnabled(
  handler: (detail: CommunityThreadNotificationsAutoEnabledDetail) => void,
): () => void {
  const fn = (event: Event) => {
    const custom = event as CustomEvent
    const detail = (custom && (custom as any).detail) || null
    const contextType = detail?.contextType
    if (contextType !== 'opportunity' && contextType !== 'analysis' && contextType !== 'vision' && contextType !== 'chat') return
    const id = normalizeContextId(detail?.contextId)
    if (!id) return
    handler({ contextType, contextId: id })
  }

  try {
    window.addEventListener(COMMUNITY_THREAD_NOTIFICATIONS_AUTO_ENABLED, fn)
    return () => window.removeEventListener(COMMUNITY_THREAD_NOTIFICATIONS_AUTO_ENABLED, fn)
  } catch {
    return () => {}
  }
}
